"use strict";
/**
 * SteamService.ts
 * Real Steam OpenID 2.0 Integration & Steam Web API synchronizer for Meci.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.steamService = void 0;
class SteamService {
    constructor() {
        this.listeners = new Set();
        this.pollInterval = null;
        if (typeof window !== 'undefined') {
            this.setupOAuthListeners();
            this.refreshStatus();
            this.initBackgroundPoller();
        }
    }
    /**
     * Listen for window message from Steam OpenID callback popup
     */
    setupOAuthListeners() {
        window.addEventListener('message', (event) => {
            if (event.data?.type === 'MECI_STEAM_CONNECTED') {
                const data = event.data;
                if (data.steamId && data.personaName) {
                    localStorage.setItem('meci_conn_steam', data.personaName);
                    localStorage.setItem('meci_steam_id', data.steamId);
                    if (data.avatar)
                        localStorage.setItem('meci_steam_avatar', data.avatar);
                    if (data.profileUrl)
                        localStorage.setItem('meci_steam_profile_url', data.profileUrl);
                    if (data.currentGame) {
                        localStorage.setItem('meci_steam_game', data.currentGame);
                    }
                    else {
                        localStorage.removeItem('meci_steam_game');
                    }
                    if (localStorage.getItem('meci_conn_steam_show') === null) {
                        localStorage.setItem('meci_conn_steam_show', 'true');
                    }
                    this.notify();
                }
            }
        });
    }
    /**
     * Periodically check if the user is playing a game on Steam
     */
    initBackgroundPoller() {
        if (this.pollInterval)
            clearInterval(this.pollInterval);
        // Check every 30 seconds
        this.pollInterval = setInterval(() => {
            if (this.isLoggedIn()) {
                this.refreshStatus();
            }
        }, 30000);
    }
    /**
     * Refresh current Steam status and in-game details
     */
    async refreshStatus() {
        const steamId = localStorage.getItem('meci_steam_id');
        if (!steamId)
            return;
        try {
            const res = await fetch(`https://meci.teymensel.com/oauth/steam?action=status&steamid=${encodeURIComponent(steamId)}`);
            if (res.ok) {
                const json = await res.json();
                if (json.success && json.data) {
                    const d = json.data;
                    localStorage.setItem('meci_conn_steam', d.personaName);
                    if (d.avatar)
                        localStorage.setItem('meci_steam_avatar', d.avatar);
                    if (d.profileUrl)
                        localStorage.setItem('meci_steam_profile_url', d.profileUrl);
                    if (d.currentGame) {
                        localStorage.setItem('meci_steam_game', d.currentGame);
                    }
                    else {
                        localStorage.removeItem('meci_steam_game');
                    }
                    this.notify();
                }
            }
        }
        catch (err) {
            console.warn('Steam durum senkronizasyon hatası:', err);
        }
    }
    /**
     * Open Steam OpenID 2.0 Login popup
     */
    loginWithSteam() {
        const authUrl = 'https://meci.teymensel.com/oauth/steam';
        const width = 800;
        const height = 620;
        const left = Math.max(0, (window.innerWidth - width) / 2 + window.screenX);
        const top = Math.max(0, (window.innerHeight - height) / 2 + window.screenY);
        const popup = window.open(authUrl, 'meci_steam_auth', `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`);
        if (popup) {
            popup.focus();
        }
        else {
            window.location.href = authUrl;
        }
    }
    isLoggedIn() {
        return !!(localStorage.getItem('meci_conn_steam') || localStorage.getItem('meci_steam_id'));
    }
    getProfile() {
        const personaName = localStorage.getItem('meci_conn_steam');
        const steamId = localStorage.getItem('meci_steam_id');
        if (!personaName && !steamId)
            return null;
        return {
            personaName: personaName || 'Steam Oyuncusu',
            steamId: steamId || '',
            avatar: localStorage.getItem('meci_steam_avatar') || '',
            profileUrl: localStorage.getItem('meci_steam_profile_url') || (steamId ? `https://steamcommunity.com/profiles/${steamId}` : 'https://steamcommunity.com/'),
            currentGame: localStorage.getItem('meci_steam_game') || undefined,
        };
    }
    isShowOnProfile() {
        return localStorage.getItem('meci_conn_steam_show') !== 'false';
    }
    setShowOnProfile(val) {
        localStorage.setItem('meci_conn_steam_show', String(val));
        this.notify();
    }
    disconnect() {
        localStorage.removeItem('meci_conn_steam');
        localStorage.removeItem('meci_steam_id');
        localStorage.removeItem('meci_steam_avatar');
        localStorage.removeItem('meci_steam_profile_url');
        localStorage.removeItem('meci_steam_game');
        this.notify();
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    }
    notify() {
        this.listeners.forEach(l => {
            try {
                l();
            }
            catch (e) {
                console.error(e);
            }
        });
    }
}
exports.steamService = new SteamService();
